<template>
  <el-dialog title="" append-to-body :modal="false" :visible.sync="showRecover" width="90%" :close-on-click-modal="false" 
  custom-class="dialogBox" :before-close="dialogBeforeClose">
  <div class="loginBox">
    <div>
      <div class="titleText">Reset Password</div>
      <el-form ref="form" :model="form" label-width="0" :rules="rules">
        <el-form-item label="" prop="userName">
          <el-input class="inputBox" v-model="form.userName" placeholder="Enter Your E-mail Address"></el-input>
          <span v-if="errorMessage" style="color: red;">{{ errorMessage }}</span>
        </el-form-item>
        <el-form-item label="" prop="code">
          <div class="codeBox">
            <el-input class="inputBox" v-model="form.code" placeholder="Verification code " ></el-input>
            <el-button v-show="!showCode" style="height: 40px;" size="mini" type="primary" @click="sendEmail">Get Code</el-button>
            <el-statistic 
              style="width: 150px;"
              :value="countdown"
              :format="format"
              prefix=""
              v-show="showCode"
            ></el-statistic>
          </div>
          </el-form-item>
          <el-form-item v-show="showPass" label="" prop="password">
            <el-input class="inputBox" type="password" v-model="pwd1" placeholder="Enter Your Password"></el-input>
          </el-form-item>
          <el-form-item v-show="showPass" label="" prop="password">
            <el-input class="inputBox" type="password" v-model="pwd2" placeholder="Enter Your Password Again "></el-input>
          </el-form-item>
        </el-form>

      <div class="loginBtn" v-show="showPass" @click="changePwd">Submit</div>
      <div class="loginBtn" v-show="!showPass" @click="save">Submit</div>
      <div class="createBox">
        <div>Don't have an account?</div>
        <div @click="goCreateUser">Create an Account</div>
      </div>
    </div>

  </div>
  <CreateUser ref="CreateUser" @showLogin="showLogin"/>
  </el-dialog>
</template>

<script>
import CreateUser from './CreateUser.vue'
import { SendCode, VerificationCode,ResetPassword } from '@/api/user.js'
import { sm2 } from 'sm-crypto';
import { VITE_SM_PUBLIC_KEY } from '@/assets/js/conSysUrl'
import { throttle } from 'lodash';
export default {
  components: { CreateUser },
  props:['goLogin'],
  data() {
    return {
      showRecover: false,
      form: {
        userName: '',
        code: '',
      },
      pwd1: '',
      pwd2: '',
      rules: {
        userName: [ { required: true, message: 'Please enter your email address', trigger: 'blur' }, ],
        code: [ { required: true, message: 'Please enter Verification code', trigger: 'blur' }, ],

      },
      showCode: false,
      countdown: 60,
      timer: null,
      startTime: null, 
      errorMessage: "",
      showPass: false,
      
    }
  },
  mounted() {
    this.startCountdown();
  },
  beforeDestroy() {
    // 组件销毁时清除定时器，避免内存泄漏
    if (this.timer) clearInterval(this.timer);
  },
  computed: {
    format() {
      return `${this.countdown} s`;
    },
  },
  methods: {
    validateEmail() {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;
      if (!this.form.userName) {
        this.errorMessage = "Please enter your email address";
      } else if (!emailRegex.test(this.form.userName)) {
        this.errorMessage = "Please provide a valid email address.";
      } else {
        this.errorMessage = ""; // 验证通过，清空错误信息
      }
    },
    startCountdown() {
      // 从本地存储中读取剩余时间
      const savedCountdown = localStorage.getItem('countdown');
      const savedStartTime = localStorage.getItem('startTime');

      if (savedCountdown && savedStartTime) {
        this.showCode = true;
        // 计算已经过去的时间
        const elapsedTime = Math.floor((Date.now() - savedStartTime) / 1000);
        this.countdown = Math.max(savedCountdown - elapsedTime, 0);

        // 如果倒计时已经结束，启用按钮
        if (this.countdown === 0) {
          this.showCode = false;
          localStorage.removeItem('countdown');
          localStorage.removeItem('startTime');
          return;
        }
        // 启动定时器
        this.timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--;
            localStorage.setItem('countdown', this.countdown);
          } else {
            clearInterval(this.timer); // 倒计时结束，清除定时器
            this.showCode = false; // 倒计时结束后启用按钮
            localStorage.removeItem('countdown');
            localStorage.removeItem('startTime');
          }
        }, 1000); // 每秒更新一次
      } 


    },
    sendEmail:throttle( async function () {
      this.validateEmail();
      if (this.errorMessage) { 
        return
      }
      this.showCode = true
      this.countdown = 60;
      this.startTime = Date.now();
      localStorage.setItem('countdown', this.countdown);
      localStorage.setItem('startTime', this.startTime);
      
      this.startCountdown()
      try {
        const { status } = await SendCode(this.form.userName)
        if (status) {
          this.$message.success("Verification code sent successfully.")
        }
      } catch (error) {
        
      }
    },500),
    goCreateUser() {
      this.dialogBeforeClose()
      this.$refs.CreateUser.show()
    },
    showLogin() {
      this.dialogBeforeClose()
      this.$emit('goLogin')
    },
    dialogBeforeClose() {
      this.$refs.form.resetFields()
      this.form ={}
      this.showRecover = false
    },
    show() {
      this.showRecover = true
    },
    async save() {
     this.$refs.form.validate(async valid => {
       if (valid) {
         const url = "?emailAds=" + this.form.userName + "&emailCode=" + this.form.code
        try {
          const { status } = await VerificationCode(url)
          if (status) {
            this.$message.success("Verification code is correct.Please enter new password.")
            this.showPass = true
          }
        } catch (error) {
          
        }
       } else {
         return false
       }
     })
    },
    async changePwd() {
      if (this.pwd1 == " " || this.pwd2 == "") {
        this.$message.error("Please enter the password.")
        return
      }
      if (this.pwd1 != this.pwd2) { 
        this.$message.error("The two passwords are inconsistent.")
        return
      }
      if (this.pwd1.length < 6) { 
        this.$message.error("The password must be at least 6 digits.")
        return
      }
      const publicKey = VITE_SM_PUBLIC_KEY;
      this.form.password = sm2.doEncrypt(this.pwd1, publicKey, 1)
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const url = "?emailAds=" + this.form.userName + "&emailCode=" + this.form.code + "&psd=" + this.form.password
            const { status } = await ResetPassword(url)
            if (status) {
              this.$message.success("Password reset! Redirecting to login...")
              setTimeout(() => {
                this.dialogBeforeClose()
                this.showLogin()
              },1000)
            }
          } catch (error) {
            
          }
        } else {
          return false
        }
      })

    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .dialogBox{
    min-width: 350px;
    max-width: 626px;
  }
  .el-dialog__body{
    padding: 10px;
  }
  .el-input__inner{
    border-radius: 10px;
    background: #f4f4f4;
  }
  .el-dialog__headerbtn{
    font-size: 30px;
    font-weight: 600;
  }
}

.loginBox{
  width: 100%;
  >div{
    margin: 0 auto;
    width: 300px;
    .titleText{
      color: #181818;
      font-size: 24px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 20px;
    }
    .codeBox{
      display: flex;
      align-items: center;
      // margin-bottom: 20px;
    }
    .inputBox{
      // margin: 10px 0;
    }
    .forgotText{
      margin: 10px 0;
      font-size: 12px;
      color: #cbac92;
      text-align: end;
    }
    .loginBtn{
      margin: 0 auto;
      text-align: center;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      background-color: #000;
      font-weight: 600;
      color: #fff;
    }
    .loginBtn:hover{
     background: #cbac92;
     color: #000;
    }
    .createBox{
      margin: 30px 0;
      text-align: center;
      font-size: 14px;
      >div:nth-child(2){
        cursor: pointer;
        color: #cbac92;
      }
    }
  }


}



</style>